import React, { useEffect, useRef, useState } from 'react';

import { Backdrop as BackdropBase, BackdropProps } from '@mui/material';

import useStyles from './styles';

interface Props extends BackdropProps {
    delay?: number;
    mask?: string;
}

const BackDrop: React.FC<Props> = ({ open, mask, delay, className, style, ...props }) => {
    const { classes, cx } = useStyles();

    const delayRef = useRef<ReturnType<typeof window.setTimeout>>();

    const [isOpen, setIsOpen] = useState(open);

    useEffect(() => {
        clearTimeout(delayRef.current);

        if (open) {
            if (delay) {
                delayRef.current = setTimeout(() => setIsOpen(true), delay);
            } else {
                setIsOpen(true);
            }
        } else {
            setIsOpen(false);
        }

        return () => clearTimeout(delayRef.current);
    }, [delay, open]);

    return (
        <BackdropBase
            open={isOpen}
            className={cx(classes.backdrop, className)}
            mountOnEnter
            unmountOnExit
            style={{ ...style, mask }}
            {...props}
        />
    );
};

export default BackDrop;
